export default __webpack_public_path__ + "static/media/screen.5d3e3b90.png";